import React, { useEffect, useState } from "react";
import { ResponsiveBar } from "@nivo/bar";
import { ResponsivePie } from "@nivo/pie";
import axios from "axios";

export default function EngPendingByName() {
  const [barData, setBarData] = useState([]);
  const [pieData, setPieData] = useState([]);

  const fetchData = async () => {
    try {
      const res = await axios.get("http://localhost:5000/api/eng-pending-byname");
      const data = res.data;

      // ✅ Only keep activities with at least one assigned
      const filtered = data.filter(row => row.total_assigned > 0);

      // ✅ Bar chart data (own vs others)
      const barChart = filtered.map(row => ({
        activity: row.activity_name,
        own_pending: row.own_pending || 0,
        other_pending: row.other_pending || 0,
      }));
      setBarData(barChart);

      // ✅ Pie chart (total pending per activity)
      const pieChart = filtered.map(row => ({
        id: row.activity_name,
        label: row.activity_name,
        value: (row.own_pending || 0) + (row.other_pending || 0),
      }));
      setPieData(pieChart);

    } catch (err) {
      console.error("❌ Error fetching EngPendingByName data:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ✅ Bar chart settings
  const barSettings = {
    keys: ["own_pending", "other_pending"],
    indexBy: "activity",
    margin: { top: 50, right: 50, bottom: 120, left: 60 },
    padding: 0.3,
    axisBottom: {
      tickRotation: -45,
      legend: "Activity Name",
      legendPosition: "middle",
      legendOffset: 80,
    },
    axisLeft: { legend: "Pending Count", legendPosition: "middle", legendOffset: -40 },
    colors: ["#36A2EB", "#FF6384"],
    groupMode: "grouped",
    legends: [
      {
        dataFrom: "keys",
        anchor: "bottom",
        direction: "row",
        justify: false,
        translateY: 60,
        itemsSpacing: 10,
        itemWidth: 120,
        itemHeight: 20,
        itemDirection: "left-to-right",
        symbolSize: 15,
      },
    ],
  };

  // ✅ Pie chart settings
  const pieSettings = {
    margin: { top: 40, right: 80, bottom: 80, left: 80 },
    innerRadius: 0.5,
    padAngle: 0.7,
    cornerRadius: 3,
    activeOuterRadiusOffset: 8,
    colors: { scheme: "set3" },
    borderWidth: 1,
    borderColor: { from: "color", modifiers: [["darker", 0.2]] },
    arcLinkLabelsSkipAngle: 10,
    arcLinkLabelsTextColor: "#333",
    arcLinkLabelsThickness: 2,
    arcLinkLabelsColor: { from: "color" },
    arcLabelsSkipAngle: 10,
    arcLabelsTextColor: { from: "color", modifiers: [["darker", 2]] },
  };

  return (
    <div style={{ padding: "30px", background: "#f9f9f9", minHeight: "100vh" }}>
      <h1 style={{ marginBottom: "30px", color: "#333" }}>Pending Status by Activity</h1>

      {/* ✅ Bar Chart */}
      <div style={{ height: 500, background: "#fff", padding: "20px", borderRadius: "12px", marginBottom: "50px" }}>
        <h3>Bar Chart: Own vs Others Pending</h3>
        <ResponsiveBar data={barData} {...barSettings} />
      </div>

      {/* ✅ Pie Chart */}
      <div style={{ height: 500, background: "#fff", padding: "20px", borderRadius: "12px" }}>
        <h3>Pie Chart: Total Pending by Activity</h3>
        <ResponsivePie data={pieData} {...pieSettings} />
      </div>
    </div>
  );
}
